import React, { useContext } from 'react'
import { PageContext } from 'utils/context'
import TBBLink from 'utils/TBBLink'

const BackButton = ({blok}) => {
    const {
        breadcrumb: { crumbs },
    } = useContext(PageContext)

    return (
        <div className={`py-12 bg-white`}>
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                {crumbs[crumbs.length - 1].crumbLabel !== "editor" &&
                    <TBBLink
                        className={`text-xs font-body capitalize font-bold`}
                        to={crumbs[crumbs.length - 2].pathname}
                    >
                        <i className="fas fa-chevron-left mr-4"></i>
                        {blok.custom_title ?
                            blok.custom_title
                            : crumbs[crumbs.length - 2].crumbLabel.replace(/-/g, " ").replace(/_/g, " ")
                        }
                    </TBBLink>
                }

                {crumbs[crumbs.length - 1].crumbLabel === "editor" && 
                    <p className="text-sm text-[red] font-bold">
                        Breadcrumbs are generated at build time and cannot be viewed in the editor.
                    </p>
                }
            </div>
        </div>
    )
}

export default BackButton